var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"m-vod"},[_c('img',{ref:"myImg",staticStyle:{"width":"100%","display":"block"},attrs:{"src":_vm._f("urlFilter")(_vm.live_banner),"alt":""}}),_c('div',{staticClass:"content",attrs:{"id":"player"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }